import type {
  AssetsBatchUpdateVariables,
  AssetsBatchUpdateVariablesData,
} from "./assets.type";
import type { AssetLite } from "@/entities/asset";
import type { UseBatchOptions } from "@/hooks/queries";

import { useBatch } from "@/hooks/queries";

export const useAssetsBatchUpdate = (
  assets: AssetLite[],
  options?: UseBatchOptions
) => {
  const { mutate: mutateFn, ...mutationResult } =
    useBatch<AssetsBatchUpdateVariables>("assets", "update", options);

  const mutate = (value: AssetsBatchUpdateVariablesData) => {
    const ids = assets.map((a) => a.id);
    mutateFn({ assets: ids, ...value });
  };

  return {
    ...mutationResult,
    mutate,
  };
};
